import React from "react";


import { Link } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import logo from '../../images/THINKBIG-INFO-PNG-B.png'

import Services from '../../api/Services';
import ProductsData from '../products/productsData';

const Header = (props) => {
  // Add custom style for navbar link hover/touch
  const navHighlightStyle = `
    .navigation-holder .nav > li > a:hover,
    .navigation-holder .nav > li > a:active,
    .navigation-holder .nav > li > a:focus {
      color: #FFC107 !important;
    }
    .navigation-holder .nav > li > a:visited:active {
      color: #FFC107 !important;
    }
    .navigation-holder .nav > li > a:active {
      color: #FFC107 !important;
    }
    .navigation-holder .nav > li > a:focus-visible {
      color: #FFC107 !important;
    }
    .navigation-holder .nav > li > a:active, .navigation-holder .nav > li > a:focus, .navigation-holder .nav > li > a:target {
      color: #FFC107 !important;
    }
  `;
  const ClickHandler = () => { 
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header id="header">
      <style>{navHighlightStyle}</style>
      <div className={" " + props.hclass}>
        <nav className="navigation navbar navbar-expand-lg navbar-light fixed-top" style={{ background: '#fff', color: '#222', minHeight: '80px', height: '80px' }} >
          <div className="container">
            <div className="row align-items-center w-100">
              <div className="col-lg-3 col-md-3 col-3 d-lg-none">
                <MobileMenu />
              </div>
              <div className="col-lg-2 col-md-6 col-6">
                <div className="navbar-header">
                  <Link className="navbar-brand w-100 d-flex align-items-center justify-content-center justify-content-lg-start" to="/home">
                    <img
                      src={logo}
                      alt="logo"
                      className=""
                      style={{
                        width: '100%',
                        maxWidth: '150px',
                        height: 'auto',
                        display: 'block'
                      }}
                    />
                  </Link>
                </div>
              </div>


              <div className="col-lg-7 col-md-1 col-1 d-flex justify-content-end align-items-center">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <ul className="nav navbar-nav mb-2 mb-lg-0" style={{ color: '#222', fontSize: '0.82rem' }}>
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/" style={{ color: '#222' }}>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/about" style={{ color: '#222' }}>
                        About
                      </Link>
                    </li> 

                    <li className="menu-item-has-children">
                      <Link to="/services" style={{ color: '#222' }}>
                        Services
                      </Link>
                      <ul className="sub-menu">
                        {Services.map((service) => (
                          <li key={service.Id}>
                            <Link to={`/services/${service.slug}`}>{service.title}</Link>
                          </li>
                        ))}
                      </ul>
                    </li>



                    <li className="menu-item-has-children">
                      <Link to="/products" style={{ color: '#222' }}>
                        Products
                      </Link>
                      <ul className="sub-menu">
                        {ProductsData.map((product) => (
                          <li key={product.Id}>
                            <Link to={`/products/${product.slug}`}>{product.title}</Link>
                          </li>
                        ))}
                      </ul>
                    </li>

                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/career" style={{ color: '#222' }}>
                        Careers
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/contact" style={{ color: '#222' }}>
                        Contact
                      </Link>
                    </li>

                    {/* <li className="d-flex align-items-center p-4">
                       <i className="fi flaticon-phone-call pe-2 icon-link-icon-size" ></i>
                      <ul className="d-flex flex-column align-items-center">
                        <a href="" className="p-0" style={{ color: '#222', fontSize:'16px' }} >
                          Call to our Experts
                        </a>
                        <a href="tel:+919363628810" className="p-0" style={{ color: '#222' , fontSize:'16px'}} >
                          +91 93636 28810
                        </a>
                      </ul> 
                    </li> */}
                    {/* <li>
                      <a href="mailto:Info@Tbiti.Com" className="nav-link d-flex align-items-center" style={{color: '#222', marginRight: '18px'}}>
                        <i className="fi flaticon-email" style={{marginRight: '6px', fontSize: '18px'}}></i> Info@Tbiti.Com
                      </a>
                    </li>*/}
                  </ul>
                </div>
                {/* Removed separate icons section, now included in nav */}
              </div>

              <div className="col-lg-3 col-md-1 col-1 d-flex justify-content-end align-items-center">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder d-flex justify-content-end"
                >
                  <li className="d-flex align-items-center justify-content-end  p-0">
                    <i className="fi flaticon-phone-call pe-2 icon-link-icon-size" ></i>
                    <ul className="d-flex flex-column align-items-center">
                      <a href="tel:+914445898141" className="p-0" style={{ color: '#222', fontSize: '16px' }} >
                        Call to our Experts
                      </a>
                      <a href="tel:+914445898141" className="p-0" style={{ color: '#222', fontSize: '16px' }} >
                        +91 44 4589 8141
                      </a>
                    </ul>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
  };
};

export default connect(mapStateToProps, { removeFromCart })(Header);
